export default function Logo({ size = "md", variant = "color", showWord = true }) {
  const dims = { sm: 28, md: 36, lg: 56 }[size] || 36;
  const text = { sm: "text-base", md: "text-xl", lg: "text-3xl" }[size];
  const color = variant === "white" ? "text-primary-foreground" : "text-primary";
  return (
    <div className="flex items-center gap-2.5" data-testid="brand-logo">
      <img
        src="/brand/logo-icon.png"
        alt="GuardianNest"
        width={dims}
        height={dims}
        className="rounded-md"
      />
      {showWord && (
        <span className={`font-heading font-extrabold tracking-tight ${text} ${color}`}>
          Guardian<span className={variant === "white" ? "text-accent" : "text-accent"}>Nest</span>
        </span>
      )}
    </div>
  );
}
